import { render, staticRenderFns } from "./item_add.vue?vue&type=template&id=b55a9960&"
import script from "./item_add.vue?vue&type=script&lang=ts&"
export * from "./item_add.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports